const Style = {
  input: `float-left relative w-6 h-6 cursor-pointer mr-2 bg-none 
  !border !border-solid !border-slate-900 bg-center appearance-none
  checked:bg-[url('components/form/checkbox/icons/ico-check-black.svg')]
  checked:bg-transparent checked:border-slate-900 checked:bg-[length:12px]
  indeterminate:bg-[linear-gradient(#0f172a,#0f172a)] indeterminate:bg-[length:12px_2px]
  indeterminate:bg-center indeterminate:bg-no-repeat indeterminate:border-slate-900 p-1`,
  label: 'cursor-pointer normal-case inline-flex items-center h-6 leading-none mb-0',
};

export default Style;
